<div
  cdkDragBoundary=".drag-area"
  cdkDrag
  cdkDragRootElement="gh-nav-list-item"
  [cdkDragDisabled]="config.itemsGroupType !== 'favorites'"
  [ngClass]="{ 'menu-opened': isMenuOpened }"
  class="nav-list-item-container fs-12px fw-500 ink-60-v3 hov-cursor-p centered-vert d-flex">
  <div *ngIf="config.itemsGroupType === 'favorites'" cdkDragHandle class="drag-handle gh-font-icon-move fs-14px hov-cursor-g h-28px w-24px flex-n pl-4px pt-6px"></div>
  <gh-nav-list-item-icon [itemsType]="config.itemsType" [item]="item"></gh-nav-list-item-icon>
  <div class="item-title ellipsis pt-5px mr-3px h-28px flex-a" (click)="view(item)">
    {{ item.title }}
  </div>
  <!-- <gh-nav-list-item-context-menu 
        (menuToggled)="onMenuToggled($event)"
        [item]="item"  
        [config]="{ itemsType: config.itemsType, itemsGroupType: config.itemsGroupType }">
    </gh-nav-list-item-context-menu> -->
  <div class="grey-background"></div>
</div>
